// Import dependencies
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
const { isEmpty } = _uo.utility;

// Translatable strings
const strings = UncannyAutomator._core.i18n.components.item;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-options' )
export class AutomatorBuilderItemOptions extends LitElement {
	// Properties
	// The item ID (post ID)
	@property( { type: Number, attribute: 'item-id' } ) accessor itemID;

	// The item code. e.g. VIEWPAGE
	@property( { type: String, attribute: 'item-code' } ) accessor itemCode;

	// The integration code. e.g. WP
	@property( { type: String, attribute: 'integration-code' } ) accessor integrationCode;

	// The item type (e.g. `"trigger"`)
	@property( { type: String, attribute: 'item-type' } ) accessor itemType;

	// The ID of the options group that's open
	@property( { type: String, attribute: 'options-group-code' } ) accessor optionsGroupCode;

	// The field _values_
	@property( { type: Array, attribute: false } ) accessor fieldsValues = [];

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uap-builder-item-legacy-form
				item-id=${ this.itemID }

				.fieldsDirectory=${ this.fieldsDirectory }
				.fieldsValues=${ this.fieldsValues }

				return-format="legacy-meta"
			></uap-builder-item-legacy-form>
		`;
	}

	/**
	 * Returns the directory fields of this option group
	 *
	 * @return {Array} The directory fields
	 */
	get fieldsDirectory() {
		// Get the item
		const item = UncannyAutomator._core.directory.items.getItem(
			this.integrationCode,
			this.itemType,
			this.itemCode
		);

		if ( isEmpty( item.fields ) ) {
			return [];
		}

		if ( isEmpty( item.fields[ this.optionsGroupCode ] ) ) {
			return [];
		}

		return item.fields[ this.optionsGroupCode ];
	}
}
